export const breakpoints = {
    xs: '320px',   // Extra small phones
    sm: '480px',   // Small phones
    md: '768px',   // Tablets
    lg: '1024px',  // Laptops/smaller desktops
    xl: '1280px',  // Desktops
    xxl: '1440px'  // Large desktops
};

// Helper functions for styled-components
export const media = {
    xs: `@media (max-width: ${breakpoints.xs})`,
    sm: `@media (max-width: ${breakpoints.sm})`,
    md: `@media (max-width: ${breakpoints.md})`,
    lg: `@media (max-width: ${breakpoints.lg})`,
    xl: `@media (max-width: ${breakpoints.xl})`,
    xxl: `@media (max-width: ${breakpoints.xxl})`
};